import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router'
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import {VideoEmailBase} from '../base/videoEmail';
import { VideoEmailAPI } from '../../services/videoEmailAPI';
import { AccountAPI } from '../../services/accountAPI';
import { EnvironmentService } from '../../services/environmentService';

@inject(AuthService, UserMessageService, Router, VideoEmailAPI, AccountAPI, EnvironmentService)
export class VideoEmail extends VideoEmailBase {
    constructor(authService, userMessageService, router, api, accountApi, envService) {
        super(authService, userMessageService, router, "api", api, accountApi, envService);
        this.dashboardlength = 'col-sm-12';
        this.isdashboard = false;
        this.captureType = window.location.href.split("=")[1]
        console.log("captureType in email",this.captureType);
    }
    onNavigate() {
        this.navPanelClass = '';
      }
    

    navigateLink(route, replace = false) {
        console.log("route param123",route);
        localStorage.setItem('rout', route);
        if(route.includes("#/user/video/email"))
        {
          if(route.includes("upload"))
          route = route + "?captureType=3" + "?videoUpload=1";
          else
          route = route + "?captureType=3";
          // window.location.href = "Posts?Category=" + sel;
        }
        if(route.includes("#/user/home") || route == "#/user" || route === "#/user/video/request" || route === "#/user/video/caseStudy" || route.includes("#/user/video/email"))
        {
          this.isdashboard = true;
          this.dashboardlength = 'col-sm-12';
          console.log("Dashboard value is",this.isdashboard);
          // window.location.href = "Posts?Category=" + sel;
        }
        else
        {
          this.isdashboard = false;
          this.dashboardlength = 'col-sm-9';
          console.log("Dashboard value is",this.isdashboard);
        }
        this.router.navigate(route, { replace: replace });
        this.onNavigate();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }


}
